module.exports = __webpack_public_path__ + "img/83d479f.jpg";